module.exports = __webpack_public_path__ + "images/lpage-newsfeed-2.png";